import * as React from "react"

import { cn } from "@/lib/utils"

interface SwitchProps {
  checked?: boolean;
  onCheckedChange?: (checked: boolean) => void;
  disabled?: boolean;
  className?: string;
}

const Switch = React.forwardRef<HTMLButtonElement, SwitchProps>(
  ({ checked = false, onCheckedChange, disabled = false, className }, ref) => {
    return (
      <button
        ref={ref}
        type="button"
        role="switch"
        aria-checked={checked}
        disabled={disabled}
        onClick={() => !disabled && onCheckedChange?.(!checked)}
        className={cn(
          "relative inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full border transition-colors duration-200",
          "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/20 focus-visible:ring-offset-2",
          disabled && "cursor-not-allowed opacity-50",
          className
        )}
        style={{
          backgroundColor: checked ? 'hsl(var(--primary))' : 'hsl(var(--app-surface-muted))',
          borderColor: checked ? 'hsl(var(--primary))' : 'hsl(var(--app-border-subtle))',
          padding: '2px',
        }}
      >
        <span
          aria-hidden="true"
          style={{
            display: 'block',
            width: '18px',
            height: '18px',
            borderRadius: '9999px',
            backgroundColor: '#ffffff',
            boxShadow: '0 1px 2px rgba(15, 23, 42, 0.18)',
            transform: checked ? 'translateX(20px)' : 'translateX(0px)',
            transition: 'transform 200ms ease-in-out',
          }}
        />
      </button>
    );
  }
);

Switch.displayName = "Switch";

export { Switch }
